import React, { FC, useState, useEffect } from "react";
import PlainHtml from "../PlainHtml";
import { CustomAccordion } from "../CustomAccordion";
import DynamicBanner from "../DynamicBanner";
import {
  CARDS_SECTION,
  DYNAMIC_TYPE,
  HTML_TEMPLATES,
} from "../../helpers/contants";
import DestiniLocator from "../DestiniLocator";
import Coupon from "../Coupon";
import { RecipesSection } from "../../components/RecipeLanding";
import FeaturedRecipe from "../../components/FeaturedRecipe";
import BlogHero from "../BlogHero";
import DynamicForm from "../DynamicForm";
import DynamicSingleForm from "../DynamicSingleForm";
import QuestionsAndAnswers from "../QuestionsAndAnswers";
import DynamicBannerTemplate2 from "../DynamicBannerTemplate2";
import CardsSection from "../CardsSection";
import ImageWithText from "../ImageWithText";
import WeBelieve from "../WeBelieve";
import MeetFromPlants from "../MeetFromPlants";
import OurImpact from "../OurImpact";
import EatWhatYouLove from "../EatWhatYouLove";
import TransparentImage from "../TransparentImage";
import SearchRecipe from "../SearchRecipe";
import InfiniteHorizontalCards from "../InfiniteHorizontalCards";
import DynamicCards from "../DynamicCards";
import { CardsSection2 } from "../CardsSection2";
import {
  DynamicContainerProps,
  SectionType,
} from "./types";
import QuoteCards from "../QuoteCards";
import {
  AccordionContainer,
  BlogHeroWrapper,
  Container,
  StyledTabs,
} from "./styles";
import VideoCardsCarousel from "../VideoCardsCarousel";
import TextWithBackgroundImage from "../TextWithBackgroundImage";
import { DynamicHtmlSection } from "../DynamicHtmlSection";
import PillsSection from "../PillsSection";
import TableWithImageSection from "../TableWithImageSection";

const DynamicContainer: FC<DynamicContainerProps> = ({
  sections,
}: DynamicContainerProps) => {
  let hash: string | null = null;
  if (typeof window !== "undefined")
    hash = window.location.hash;

  const getBackgroundColor = () => {
    if (typeof window !== "undefined") {
      return window?.location?.pathname === "/join-the-team"
        ? "var(--color-white)"
        : undefined;
    }
  };

  return (
    <>
      {sections?.map((section: SectionType) => {
        if (
          section?.type === DYNAMIC_TYPE.PLAIN_HTML &&
          (section?.content?.template ==
            HTML_TEMPLATES.PLAIN_HTML_TYPE_1 ||
            !section?.content?.template)
        ) {
          return (
            <DynamicHtmlSection
              key={section?.slug}
              {...section?.content}
              backgroundColor={
                section?.content?.backgroundColor ||
                getBackgroundColor()
              }
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.COUPON) {
          return (
            <Coupon
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.DESTINI_LOCATOR
        ) {
          return (
            <DestiniLocator
              key={section?.slug}
              {...section?.content}
              backgroundColor={"var(--color-green-90)"}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.ACCORDION) {
          return (
            !!section?.content?.length && (
              <Container key={section?.slug}>
                <AccordionContainer id={section?.slug}>
                  {section?.content?.map(
                    (accordion, index: number) => (
                      <CustomAccordion
                        key={index}
                        slug={accordion?.element_slug}
                        title={accordion?.title}
                        text={accordion?.description}
                      />
                    ),
                  )}
                </AccordionContainer>
              </Container>
            )
          );
        }
        if (section?.type === DYNAMIC_TYPE.TABS) {
          return (
            !!section?.content?.length && (
              <Container className="bg-color-linen" key={section?.slug}>
                <StyledTabs
                  id={section?.slug}
                  key={section?.slug}
                  activeColor="var(--color-green-30)"
                  color={"var(--color-white)"}
                  tabs={section?.content?.map((tabItem) => {
                    let activeTab = false;
                    const children = tabItem?.content?.map(
                      (innerSection) =>
                        innerSection?.type ===
                        DYNAMIC_TYPE.PLAIN_HTML ? (
                          <PlainHtml {...innerSection} />
                        ) : (
                          innerSection?.content?.map(
                            (accordion, index: number) => {
                              if (hash && !activeTab) {
                                activeTab =
                                  accordion?.element_slug ===
                                  hash?.substr(1);
                              }
                              return (
                                <CustomAccordion
                                  key={index}
                                  slug={
                                    accordion?.element_slug
                                  }
                                  title={accordion?.title}
                                  text={
                                    accordion?.description
                                  }
                                  color={`var(--color-white)`}
                                />
                              );
                            },
                          )
                        ),
                    );

                    return {
                      id: tabItem?.slug,
                      title: tabItem?.title,
                      children,
                      isActive: activeTab,
                    };
                  })}
                />
              </Container>
            )
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.BANNER &&
          section?.content?.type ==
            DYNAMIC_TYPE.BANNER_TYPE_1
        ) {
          return (
            <DynamicBanner
              key={section?.slug}
              slug={section?.slug}
              content={section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.BANNER &&
          section?.content?.type ==
            DYNAMIC_TYPE.BANNER_TYPE_2
        ) {
          return (
            <DynamicBannerTemplate2
              key={section?.slug}
              slug={section?.slug}
              content={section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.FEATURED_RECIPES
        ) {
          const [recipesStyles, setRecipesStyle] = useState(
            {},
          );

          useEffect(() => {
            setRecipesStyle(section?.content?.styles);
          }, []);

          return (
            <RecipesSection
              key={section?.slug}
              {...section?.content}
              {...recipesStyles}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.FEATURED_RECIPE
        ) {
          return (
            <FeaturedRecipe
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.FEATURED_CONTENT_SECTION
        ) {
          return (
            <FeaturedRecipe
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.FEATURED_ARTICLE
        ) {
          return (
            <BlogHeroWrapper>
              <BlogHero
                key={section?.slug}
                {...section?.content?.hero}
              />
            </BlogHeroWrapper>
          );
        }
        if (section?.type === DYNAMIC_TYPE.MULTIPLE_FORM) {
          return (
            <DynamicForm
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.SINGLE_FORM) {
          return (
            <DynamicSingleForm
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.FAQ_SECTION) {
          return (
            <QuestionsAndAnswers
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.CARDS_SECTION &&
          (section?.content?.type ==
            CARDS_SECTION.TEMPLATE_1 ||
            !section?.content?.type)
        ) {
          return (
            <CardsSection
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.CARDS_SECTION &&
          section?.content?.type == CARDS_SECTION.TEMPLATE_2
        ) {
          return (
            <CardsSection2
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.IMAGE_WITH_TEXT_SECTION
        ) {
          return (
            <ImageWithText
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.INFINITE_HORIZONTAL_CARDS
        ) {
          return (
            <InfiniteHorizontalCards
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.HERO_WITH_FIVE_IMAGES
        ) {
          return (
            <WeBelieve
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.ITEMS_COLLAPSIBLES
        ) {
          return (
            <MeetFromPlants
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.DYNAMIC_CAROUSEL
        ) {
          return (
            <OurImpact
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.TEXT_WITH_THREE_IMAGES
        ) {
          return (
            <EatWhatYouLove
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type === DYNAMIC_TYPE.TRANSPARENT_IMAGE
        ) {
          return (
            <TransparentImage
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.SEARCH_RECIPE) {
          return (
            <SearchRecipe
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.QUOTE_CARDS) {
          return (
            <QuoteCards
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.DYNAMIC_CARDS) {
          return (
            <DynamicCards
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.VIDEO_CARDS) {
          return (
            <VideoCardsCarousel
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.TEXT_WITH_BACKGROUND_IMAGE
        ) {
          return (
            <TextWithBackgroundImage
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (section?.type === DYNAMIC_TYPE.PILLS_SECTION) {
          return (
            <PillsSection
              key={section?.slug}
              {...section?.content}
            />
          );
        }
        if (
          section?.type ===
          DYNAMIC_TYPE.TABLE_WITH_IMAGE_SECTION
        ) {
          return (
            <TableWithImageSection
              key={section?.slug}
              {...section?.content}
            />
          );
        }
      })}
    </>
  );
};

export default DynamicContainer;
